import { type ActivityRow, formatTimestamp } from './derive';
import { tonePalette, palette } from './palette';
import { DispatchIcon, TaskIcon, EStopIcon, HandIcon } from './icons';
import type { ComponentType, SVGProps } from 'react';

const KIND_ICON: Record<ActivityRow['kind'], ComponentType<SVGProps<SVGSVGElement> & { size?: number }>> = {
  dispatch: DispatchIcon,
  task: TaskIcon,
  estop: EStopIcon,
  takeover: HandIcon,
};

export function ActivityLogRow({ row }: { row: ActivityRow }) {
  const t = tonePalette[row.tone];
  const Glyph = KIND_ICON[row.kind];
  const inProgress = row.status === 'IN PROGRESS';
  return (
    <div
      className="grid items-center gap-3 px-1 py-3.5"
      style={{
        gridTemplateColumns: '32px 1fr auto',
        borderBottom: `1px solid ${palette.hair}`,
      }}
    >
      <div
        className="flex h-7 w-7 items-center justify-center rounded-lg"
        style={{ background: t.bg, color: t.fg }}
      >
        <Glyph size={14} />
      </div>
      <div className="min-w-0">
        <div className="text-[13px] leading-snug">
          <strong className="font-semibold">{row.actor}</strong>{' '}
          <span>{row.action}</span>
          {row.target && (
            <>
              {' '}
              <strong className="font-semibold">{row.target}</strong>
            </>
          )}
          <span>.</span>
        </div>
        <div className="mt-0.5 font-mono text-[11px] text-muted">
          {formatTimestamp(row.time)} · {row.detail}
        </div>
      </div>
      <div
        className="rounded-md px-2 py-1 text-[9px] font-bold tracking-[0.14em]"
        style={{
          background: inProgress ? palette.dark : 'transparent',
          color: inProgress ? '#fff' : t.fg,
          border: inProgress ? 'none' : `1px solid ${palette.hair}`,
        }}
      >
        {row.status}
      </div>
    </div>
  );
}
